import { render, staticRenderFns } from "./BeneficiariosPorcentaje.vue?vue&type=template&id=846452ae&scoped=true"
import script from "./BeneficiariosPorcentaje.vue?vue&type=script&lang=js"
export * from "./BeneficiariosPorcentaje.vue?vue&type=script&lang=js"
import style0 from "./BeneficiariosPorcentaje.vue?vue&type=style&index=0&id=846452ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846452ae",
  null
  
)

export default component.exports